import { Portal } from '@mui/material';
import { FileCollectionT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { PDFIcon, ExcelIcon, DocumentIcon } from '../../../../../icons/appIcons';
import { ObosX, ObosDownload } from '../../../../../icons/obos/obosIcons';
import { isMobile } from '../../../../../utils/app.helper';
import { Modal } from '../../../../overlay';

type ObjectViewMobileIframeModalProps={
    showIframeModal: boolean;
    setShowIframeModal: (value: boolean) => void;
};

const ObjectViewMobileIframeModal: React.FC<ObjectViewMobileIframeModalProps> = ({ children, setShowIframeModal, showIframeModal }): ReactElement => {

    return (
        <>{showIframeModal && <Portal>
            <Modal
                showModal={showIframeModal}
                onBackdropClick={(): void => setShowIframeModal(false)}
                modalPaperStyle={{
                    maxWidth: 'calc(100% - 2rem)',
                    height:'calc(100% - 2rem)',
                    maxHeight: 'calc(80vh - 2rem)',
                    width:'calc(100% - 2rem)',
                    borderRadius: '2rem',
                    overflow:'hidden',
                    margin: isMobile() ? 'unset' : '32px' }}>
                <div className={'bv-objectview-close'} style={{ width: '3rem', height: '3rem', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.5)' }} onClick={():void => setShowIframeModal(false)}>
                    <ObosX className={'bv-obos-x'}
                        style={{
                            width: '1.5rem',
                            height: '1.5rem',
                            padding: '0.75rem' }} />
                </div>
                {children}
            </Modal>
        </Portal>}</>
    );
};


export default ObjectViewMobileIframeModal;